import type { Flag } from '~/shared/api/data-ingestion-api/client'

/** Determines EOB Processing stepper flag severity from active patient_claim flags.
 * Returns 'high' if any active patient_claim flag is unreviewed.
 * Returns 'low' when all active patient_claim flags have metadata.reviewed === true.
 * Returns null if no active patient_claim flags. */
export function getStepperFlagSeverity(flags: Flag[]): 'high' | 'low' | null {
  const activeClaimFlags = flags.filter(
    (flag) => flag.flag_type === 'patient_claim' && flag.flag_status === 'pending',
  )
  if (activeClaimFlags.length === 0) return null

  const allReviewed = activeClaimFlags.every(
    (flag) => (flag.metadata as Record<string, unknown>)?.reviewed === true,
  )

  return allReviewed ? 'low' : 'high'
}
